import axiosInstanceNode from "./axiosInstanceNode";

/*Check if email exists (for login verification)*/
export const checkEmailExists = async (email) => {
  try {
    const response = await axiosInstanceNode.post(
      "/auth/login-verify",
      {
        email,
      },
      { skipGlobalErrorToast: true },
    );
    if (response.data.success === true) {
      return { exists: true };
    } else {
      return { exists: false, message: response.data.message };
    }
  } catch (error) {
    return { exists: false, message: error.response?.data?.message };
  }
};

/**
 * Register a new user
 */
export const registerUser = async ({ email, password, name }) => {
  try {
    const response = await axiosInstanceNode.post("/auth/register", {
      email,
      password,
      name,
    });
    return response.data;
  } catch (error) {
    const payload = error.response?.data;
    throw new Error(
      payload?.error || payload?.message || "An error occurred during signup.",
    );
  }
};

/**
 * Login user
 */
export const loginUser = async ({ email, password }) => {
  try {
    const response = await axiosInstanceNode.post("/auth/login", {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    const payload = error.response?.data;
    const msg =
      payload?.error || payload?.message || "Invalid email or password.";
    throw new Error(msg);
  }
};

/**
 * Get organization details by user email
 */
export const getOrganizationByEmail = async (email) => {
  const response = await axiosInstanceNode.post("/auth/organization/me", {
    email,
  });
  return response.data;
};

/**
 * Request access (org_admin or superadmin approval)
 */
export const requestAccess = async ({ email, comment, target_role }) => {
  const response = await axiosInstanceNode.post(
    "/auth/request-access",
    { email, comment, target_role },
    { skipGlobalErrorToast: true },
  );
  return response.data;
};

/**
 * Fetch the current user's fresh status from the server.
 * Uses authMiddlewareForPendingApproval so pending users are allowed through.
 */
export const fetchCurrentUser = async () => {
  const response = await axiosInstanceNode.get("/auth/me", {
    skipAuthRedirect: true,
    // Lets the server send the digest email at the user's local time.
    headers: { "X-User-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone },
  });
  return response.data;
};

/**
 * Fetch company services (website-extracted suggestions) for the current user.
 */
export const fetchWebsiteServices = async () => {
  const response = await axiosInstanceNode.get("/auth/website-services");
  return response.data;
};

/**
 * Request password reset
 */
export const forgotPassword = async (email) => {
  try {
    const response = await axiosInstanceNode.post("/auth/forgot-password", {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "An error occurred. Please try again.",
    );
  }
};

export const resetPassword = async ({ token, password }) => {
  try {
    const response = await axiosInstanceNode.post("/auth/reset-password", {
      token,
      password,
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Unable to reset your password.",
    );
  }
};
